import React from 'react';
import { Col, Row } from '@gjensidige/core-grid';

import { useAppSelector } from '../hooks/appHooks';
import HeaderWithStepManager from '../components/HeaderWithStepManager/HeaderWithStepManager';
import { TextHelper } from '../utils/TextHelper';

interface HeaderContainerProps {
  productName: string;
  currentPage: string;
}
export const HeaderContainer: React.FC<HeaderContainerProps> = (
  props: HeaderContainerProps
) => {
  const offerDetails = useAppSelector((state) => state.insurance.offer);
  const thirdRowText = TextHelper.getThirdRowText(props.productName, props.currentPage);
  return (
    <>
      {
        <Row className='mt-md-4'>
          <Col
            sm="12"
            lg="12"
            md="12"
            xl="12"
            className={`py-3 header-stepper-wrapper`}
          >
            <HeaderWithStepManager
              topheaderText={TextHelper.getPageHeaderTitle(props.productName)}
              firstRowText={TextHelper.getPageDescription(
                props.productName,
                props.currentPage,
                offerDetails.customerName
              )}
              secondRowText={TextHelper.getObjectDescription(
                props.productName,
                offerDetails,
                props.currentPage
              )}
              thirdRowText={thirdRowText}
              statusJson={offerDetails.purchaseSteps}
            ></HeaderWithStepManager>
          </Col>
        </Row>
      }
    </>
  );
};
